export default "__VITE_ASSET__n22EFYtm__"